import React from 'react';

import '../css/headofschool.css'

function headofschool() {
  return (
    <div>
    {/*  <h1>Heade of school</h1>*/}
      <div className='school-head-main'>
      <div className='left-box'>
      <div className='school-head-content'>
      <h2>head of school</h2>
      <h1>Ms. Girdhar Kumari</h1>
      <h4>principal</h4>
      <h5>International Curriculum</h5>
      <p>"The beautiful thing about learning is that no one can take it away form you." - B.B.King</p>
      <p>Our Primary focus at Sanskar is to impart a child-centered, constructive approach to learning that supports creative and intellectual growth in childern. We value each child's uniqueness and thereby emphasize and encourage the processes that lead to self-discovery and self-expression. For us, each child is a success story waiting to be written and become a bestseller.</p>
      </div>
      </div>
      <div className='right-box'>
      <div  className='school-head-img'>
        <img src='../img/gidhar-kumari.webp '/>

      
      </div>
      </div>

      
      
      </div>
    </div>
  )
}

export default headofschool
